module.exports = __webpack_public_path__ + "img/UY.fce1a3a5.png";